export default __webpack_public_path__ + "static/media/menu.3f13e779.svg";